
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.15527 6C3.15527 5.44772 3.60299 5 4.15527 5H19.8442C20.3965 5 20.8442 5.44772 20.8442 6C20.8442 6.55228 20.3965 7 19.8442 7H4.15527C3.60299 7 3.15527 6.55228 3.15527 6ZM3.15527 12C3.15527 11.4477 3.60299 11 4.15527 11H19.8442C20.3965 11 20.8442 11.4477 20.8442 12C20.8442 12.5523 20.3965 13 19.8442 13H4.15527C3.60299 13 3.15527 12.5523 3.15527 12ZM3.15527 18C3.15527 17.4477 3.60299 17 4.15527 17H19.8442C20.3965 17 20.8442 17.4477 20.8442 18C20.8442 18.5523 20.3965 19 19.8442 19H4.15527C3.60299 19 3.15527 18.5523 3.15527 18Z","fill":"#16171F"}})])
          )
        }
      }
    